module.exports = __webpack_public_path__ + "static/media/nav_logo.74c3b7e7.png";